import api from './apiConfig';

// Task management services based on OpenAPI specification
const taskService = {
  /**
   * Get all tasks
   * @returns {Promise} Promise with tasks data
   */
  getAllTasks: async () => {
    try {
      const response = await api.get('/tasks');
      return response.data;
    } catch (error) {
      console.error('Error fetching tasks:', error);
      throw error;
    }
  },
  
  /**
   * Get task by ID
   * @param {string} id Task ID
   * @returns {Promise} Promise with task data
   */
  getTaskById: async (id, history = false) => {
    try {
      const url = history ? `/tasks/${id}?history=true` : `/tasks/${id}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching task ${id}:`, error);
      throw error;
    }
  },
  
  /**
   * Get task configuration
   * @param {string} id Task ID
   * @returns {Promise} Promise with task configuration
   */
  getTaskConfig: async (id) => {
    try {
      const response = await api.get(`/tasks/${id}/config`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching task config for ${id}:`, error);
      throw error;
    }
  },

  getTasksByQueue: async (queueId) => {
    const response = await api.get(`/v1/tasks?queue=${queueId}`);
    return response.data;
  },

  claimTask: async (taskId, queueId) => {
    const response = await api.post(`/tasks/${taskId}/claim`, { 
      queueId: queueId 
    });
    return response.data;
  },

  unclaimTask: async (taskId, reason) => {
    const response = await api.post(`tasks/${taskId}/release`, { reason });
    return response.data;
  },

  completeTask: async (taskId, variables = {}, reason = null) => {
    const response = await api.post(`tasks/${taskId}/complete`, { ...variables, reason });
    return response.data;
  },

  rejectTask: async (taskId, variables = {}, reason = null) => {
    const response = await api.post(`tasks/${taskId}/reject`, { ...variables, reason });
    return response.data;
  }
};

export default taskService; 